var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHidePwrd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.435,
    height: 15.322,
    viewBox: "0 0 21.435 15.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44751",
    "data-name": "Group 44751",
    transform: "translate(15664.933 20078.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M5.131,14.87A12.076,12.076,0,0,1,.675,11.617a3.053,3.053,0,0,1,0-3.829A12,12,0,0,1,14.614,4.61L16.38,2.7,14.614,4.61a12.082,12.082,0,0,1,4.281,3.177,3.053,3.053,0,0,1,0,3.829A12,12,0,0,1,5.131,14.87L3.6,16.521Z",
    transform: "translate(-15664 -20080.598)",
    fill: "none",
    stroke: "#989898",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye-svgrepo-com",
    transform: "translate(-15664 -20077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29327",
    "data-name": "Path 29327",
    d: "M15.58,12A3.58,3.58,0,1,1,12,8.42,3.576,3.576,0,0,1,15.58,12Z",
    transform: "translate(-2.215 -5.892)",
    fill: "none",
    stroke: "#c8c8c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.63
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29364",
    "data-name": "Path 29364",
    d: "M-15662.769-20069.473l10.266-11.125",
    transform: "translate(3.673 3.98)",
    fill: "none",
    stroke: "#989898",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePwrd);
export default __webpack_public_path__ + "static/media/hidePwrd.4b6f62c33afacb7f7352eb024b0aa0d9.svg";
export { ForwardRef as ReactComponent };